import { queryOptions, useQuery } from '@tanstack/react-query';

import type { TimeRange } from '@cast/shared-types';
import { NodeLabelFilters } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

const NODE_LABEL_VALUES_QUERY_KEY = 'node-label-values';

const getNodeLabelValuesQueryKey = ({
  key,
  label,
  filter,
}: {
  key: string;
  label?: string;
  filter?: string;
}) => [NODE_LABEL_VALUES_QUERY_KEY, key, label, filter] as const;

type NodeLabelValuesQuery = {
  label: string;
  clusterIds?: string[];
  key: string;
  getRange: () => TimeRange;
  filter?: NodeLabelFilters;
  enabled?: boolean;
};

const getNodeLabelValuesQueryOptions = ({
  label,
  getRange,
  key,
  filter = {},
  enabled = true,
}: NodeLabelValuesQuery) => {
  const { from, to } = getRange();

  return queryOptions({
    queryKey: getNodeLabelValuesQueryKey({
      key,
      label,
      filter: JSON.stringify(filter),
    }),
    queryFn: async () => {
      const { data } = await apiClient.costReport.getNodeLabelValues({
        label,
        startTime: from,
        endTime: to,
        labelFilters: filter,
      });

      return data.labelValues;
    },
    enabled,
  });
};

export const useNodeLabelValuesQuery = (props: NodeLabelValuesQuery) => {
  const { isLoading, data, error, refetch } = useQuery(
    getNodeLabelValuesQueryOptions(props)
  );

  return {
    labelValues: data,
    isLoading,
    error,
    refetch,
  };
};
